import React from 'react';
import './AnnotationHeading.css'
// NORTON DESIGN SYSTEM
import { Button } from '@wwnds/react';

const AnnotationHeading = ({ timeline, formatTime, formatSectionHeaderStr, updateTime, timelineIndex, Data }) => {
  return (
    <Button variant="ghost" style={{ width: "100%", padding: "0px" }} onClick={() => updateTime(timeline.frames[0].in)}
    >
      <h3 className="annotation-div-heading-container annotation-link">
        <span style={{marginRight: "0px"}}>[{formatTime(timeline.frames[0]["in-label"] ? timeline.frames[0]["in-label"] : timeline.frames[0].in)}
          <span>
            &ndash;{formatTime(timeline.frames[0]["out-label"]?timeline.frames[0]["out-label"] : timeline.frames[0].out)}</span>
          ]&nbsp;
        </span>
        <span dangerouslySetInnerHTML={{ __html: formatSectionHeaderStr(timeline.timeline, timeline.type) }}></span>
      </h3>
    </Button>
  )
}

export default AnnotationHeading